import React from 'react';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Link,
  Actions,
  Action,
  Box,
  EditIcon,
} from '@gogame/components';

const Affiliates = ({ data, onOpenAffiliates, onEditAffiliates }) => {
  return (
    <React.Fragment>
      {data && data.length ? (
        <TableContainer>
          <Table width={'100%'}>
            <TableBody>
              {data.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <Link
                      onClick={(e) =>
                        onOpenAffiliates(e, {
                          id: row.id,
                        })
                      }
                    >
                      {row.name}
                    </Link>
                  </TableCell>
                  <TableCell align={'right'} padding={'actions'}>
                    <Box display={'inline-block'}>
                      <Actions>
                        <Action
                          label={'Edit'}
                          icon={<EditIcon />}
                          onClick={(e) =>
                            onEditAffiliates(e, {
                              id: row.id,
                            })
                          }
                        />
                      </Actions>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </React.Fragment>
  );
};

export default Affiliates;
